import type { Attachment } from '@travelity/api/services';

type UploadedImageItem = {
    name: string;
    src?: string;
};

const getFilenameFromUrl = (url: string): string => {
    const name = url.split('/').pop();
    return name && name.trim().length ? name : 'Image';
};

const buildSrc = (image: Attachment): string | undefined => {
    if (image.content && image.contentType) {
        return `data:${image.contentType};base64,${image.content}`;
    }
    if (image.url) {
        return image.url;
    }
    return undefined;
};

export const normalizeImage = (image: Attachment): UploadedImageItem => {
    return {
        name:
            image.name || (image.url ? getFilenameFromUrl(image.url) : 'Image'),
        src: buildSrc(image),
    };
};

export const buildItemId = (image: Attachment, index: number): string => {
    const base =
        image.name?.trim() ||
        (image.url ? getFilenameFromUrl(image.url) : 'image');
    return `${base}-${index}`;
};
